import {
  getActiveAuthTokenSource,
  getActiveAwareAuthToken,
} from "../../../auth/bootstrapTokens";

export const CATCH_TX_PREFIX = "[CATCH_TX]";
export const CATCH_SUBMIT_SLOW_NOTICE_MS = 12000;
export const CATCH_SUBMIT_TIMEOUT_MS = 45000;
export const SUBMIT_PHASES = {
  IDLE: "idle",
  PREPARING: "preparing",
  READY: "ready",
  SUBMITTING: "submitting",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

export const buildInitialTransaction = (attemptId = 0) => ({
  attemptId,
  status: "idle",
  requestStartedAt: null,
  responseReceivedAt: null,
  postId: null,
  clientRequestId: "",
  closeRequested: false,
  refreshRequested: false,
  tokenSource: "",
});

export const computeSubmitReady = (uploadFile, blockingError) =>
  Boolean(uploadFile) && !blockingError;

export const getAuthSnapshot = () => {
  if (typeof window === "undefined") {
    return {
      source: "",
      token: "",
    };
  }

  const source = getActiveAuthTokenSource(window) || "";
  const token =
    getActiveAwareAuthToken(window) || window.localStorage.getItem("token") || "";

  return {
    source,
    token,
  };
};

export const logCatchTx = (event, details = {}) => {
  try {
    console.warn(CATCH_TX_PREFIX, event, {
      attemptId:
        Number.isFinite(details?.attemptId)
          ? details.attemptId
          : details?.attemptId ?? null,
      ...details,
    });
  } catch {
    // no-op
  }
};
